import { useState } from "react";
import { Box, Tab } from "@mui/material";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { tabbedDataGridPage } from "../../styles/commonPageStyles";
import ControlPlanes from "./ControlPlanes";

// The tab chain is stretched to the viewport so the grid inside a panel can
// claim whatever height is left below the tab list.
const fillHeight = {
  mainBox: {
    ...tabbedDataGridPage.mainBox,
    height: "100vh",
    display: "flex",
    flexDirection: "column",
  },
  tabContainer: {
    ...tabbedDataGridPage.tabContainer,
    flex: 1,
    minHeight: 0,
    display: "flex",
    flexDirection: "column",
  },
  tabPanel: {
    flex: 1,
    minHeight: 0,
    display: "flex",
    flexDirection: "column",
    paddingLeft: "4px",
  },
};

const TessellDeployments = () => {
  const [selectedTab, setSelectedTab] = useState("Control Planes");
  const tabs = [
    {
      value: "Control Planes",
      component: <ControlPlanes />,
    },
  ];
  return (
    <Box sx={fillHeight.mainBox}>
      <Box sx={fillHeight.tabContainer}>
        <TabContext value={selectedTab}>
          <Box sx={tabbedDataGridPage.tabListBox}>
            <TabList
              onChange={(e, newValue) => setSelectedTab(newValue)}
              sx={tabbedDataGridPage.tabList}
            >
              {tabs.map((tab, i) => (
                <Tab
                  key={i}
                  label={tab.value}
                  value={tab.value}
                  icon={<></>}
                  iconPosition="end"
                />
              ))}
            </TabList>
          </Box>
          {tabs.map((tab, i) => (
            <TabPanel key={i} value={tab.value} sx={fillHeight.tabPanel}>
              {tab.component}
            </TabPanel>
          ))}
        </TabContext>
      </Box>
    </Box>
  );
};

export default TessellDeployments;
